/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-page-error',
  templateUrl: 'page-error.component.html',
  styleUrls: ['page-error.component.scss'],
})
export class PageErrorComponent {
  @Input() icon: string;
  @Input() title: string;
  @Input() info: string;
}
